export default __webpack_public_path__ + "fonts/Roboto-500-cyrillic-ext15.woff2";